import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Outlet, Route, Routes } from "react-router-dom";
import "@/projects/Screener2/styles/style.css";
import routes from "@/projects/Screener2/utils/routes";
import ScreenerProtectedRouter from "./auth/ProtectedRouter";

const ScreenerApp = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <ConfigProvider
      theme={{
        hashed: false,
      }}
      componentSize="large"
    >
      <div className="screener-user-app" style={{ height: "48px" }}>
        <Routes>
          <Route element={<Outlet />}>
            {publicRoutes.map(({ path, element: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route element={<ScreenerProtectedRouter />}>
              {authRoutes.map(({ path, element: Page }) => (
                <Route key={path} path={path} element={<Page />} />
              ))}
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default ScreenerApp;
